__turbopack_context__.v({
  "btnIcon": "FeatureHero-module__b6v4SW__btnIcon",
  "btnPrimary": "FeatureHero-module__b6v4SW__btnPrimary",
  "btnSecondary": "FeatureHero-module__b6v4SW__btnSecondary",
  "buttonRow": "FeatureHero-module__b6v4SW__buttonRow",
  "centerBox": "FeatureHero-module__b6v4SW__centerBox",
  "description": "FeatureHero-module__b6v4SW__description",
  "heroSection": "FeatureHero-module__b6v4SW__heroSection",
  "mainHeading": "FeatureHero-module__b6v4SW__mainHeading",
});
